import React from "react";
import { TextField, InputAdornment } from "@mui/material";

/**
 * Thin wrapper around MUI TextField.
 *
 * - TextField wires `htmlFor` / `id` automatically: the `label` prop renders a
 *   proper <label> linked to the <input>, fixing the a11y gap found in the
 *   bespoke `CustomInput` in reusableStyles.
 * - Focus ring uses the primary (orange) color via theme override (MuiTextField
 *   in src/theme.js).
 *
 * Props:
 *   label, error, helperText, leftIcon, rightIcon, size, required
 *   ...plus any standard MUI TextField prop.
 */

const Input = React.forwardRef(function Input(
  {
    label,
    error,
    helperText,
    leftIcon,
    rightIcon,
    size = "medium",
    required,
    variant = "outlined",
    InputProps,
    ...rest
  },
  ref
) {
  const adornments = {};
  if (leftIcon) {
    adornments.startAdornment = (
      <InputAdornment position="start">{leftIcon}</InputAdornment>
    );
  }
  if (rightIcon) {
    adornments.endAdornment = (
      <InputAdornment position="end">{rightIcon}</InputAdornment>
    );
  }

  return (
    <TextField
      ref={ref}
      label={label}
      error={Boolean(error)}
      helperText={helperText}
      required={required}
      variant={variant}
      size={size}
      InputProps={{ ...adornments, ...(InputProps || {}) }}
      {...rest}
    />
  );
});

export default Input;
